import AccessServiceTile from './AccessServiceTile';
import { SERVICES } from './types';
import { observer } from 'mobx-react-lite';
import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';

interface AccessMultiServiceTilesProps {
  selectedCategory: ProductCategory;
  onSelectService?: (key: ProductCategory) => void;
  quoteIds?: Record<
    Extract<ProductCategory, 'Broadband' | 'DIA' | 'Starlink'>,
    string | undefined
  >;
}

const AccessMultiServiceTiles = observer(
  ({
    selectedCategory = 'Broadband',
    onSelectService,
    quoteIds,
  }: AccessMultiServiceTilesProps) => {
    return (
      <div className="flex w-full flex-row flex-wrap justify-center gap-6">
        {Object.values(SERVICES).map((service) => (
          <AccessServiceTile
            key={service.key}
            service={service}
            quoteId={quoteIds?.[service.key as keyof typeof quoteIds]}
            selected={selectedCategory === service.key}
            onSelect={() => onSelectService?.(service.key)}
          />
        ))}
      </div>
    );
  },
);

export default AccessMultiServiceTiles;
